
import "./performance.css";

import Header from "../../components/Header";
import Footer from "../../components/Footer";

/* react */
import { useState, useEffect, useTransition } from "react";

/* banco de dados */
import { db } from "../../services/firebaseConnection";
import { collection, getDocs, getDoc, doc, where, query, limit } from "firebase/firestore";

/* redux */
import { useSelector } from "react-redux";

/* gráficos */
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LabelList, ReferenceArea } from "recharts";

/* funções auxiliares */
import { wait } from "../../services/functions/functions.ts";

export default function Performance() {

    const { user } = useSelector((rootReducer) => rootReducer.user);
    const { agent } = useSelector((rootReducer) => rootReducer.agent);

    const [isPending1, startTransition1] = useTransition();

    const [loaded1, setLoaded1] = useState(false);

    const [dash1, setDash1] = useState(null);

    const [selectedMonth, setSelectedMonth] = useState(getMesAtual());

    useEffect(() => { window.scrollTo(0, 0); }, []);

    useEffect(() => {

        startTransition1(async () => {
            await dashs1();
            setLoaded1(true);
        });

    }, []);



    async function dashs1() {

        try {

            let aid = agent.id;

            const agentref = doc(db, "agents", aid);
            const agentdoc = await getDoc(agentref);

            const tel = agentdoc.data().telefone;
            const dta = agentdoc.data().data_inicio_ativacao.toDate();

            //busca o id do agente do gptmaker
            const telephonesdb = collection(db, "telephones");
            const telephonequery = query(telephonesdb, where("telefone", "==", tel), limit(1));
            const telephonedoc = await getDocs(telephonequery);
            
            if (telephonedoc.empty) {
                throw new Error("Telefone não encontrado");
            }
        
            const idg = telephonedoc.docs[0].data().id_gptmaker;

            wait(500);

            const resGptMaker = await fetch("https://gptmaker-services-712108985873.southamerica-east1.run.app/dashs1",
                { method: "POST", headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    agent_id: "3E2ABD6C82D6005832EF2208F26D4506", //idg,
                    start_date: "2025-07-01",
                    })
                });
           
            const resultGptMaker = await resGptMaker.json();
            if(resultGptMaker.error) {
                return;
            }

            const resumo = resultGptMaker.resumo;

            //garante os últimos 12 meses
            const ultimos12 = gerarUltimos12Meses();

            //monta array no formato esperado pelo gráfico
            const chartData = ultimos12.map((key) => {
            const valores = resumo.por_mes?.[key] || { total: 0, resolvidos: 0, nao_resolvidos: 0 };
            return {
                mes: formatarMes(key),
                concluido: valores.resolvidos,
                nconcluido: valores.nao_resolvidos,
                };
            });

            const diasDoMes = gerarDiasDoMes(2025, 10);

            const chartDataDiario = diasDoMes.map((key) => {
            const valores = resumo.por_dia?.[key] || { total: 0, resolvidos: 0, nao_resolvidos: 0 };
            return {
                dia: key.split("-")[2], // só o dia para exibir no eixo x
                concluido: valores.resolvidos,
                nconcluido: valores.nao_resolvidos,
                };
            });

            setDash1({resumo, chart: chartData, chartDiario: chartDataDiario});

            console.log("chartData", chartData, chartDataDiario);

        }
        catch(erro) {
            console.log(erro);
        }
        
    }


    function formatarMes(yyyyMm) {

        const [ano, mes] = yyyyMm.split("-");
        const nomes = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];
        return `${nomes[parseInt(mes, 10) - 1]}/${ano.slice(2)}`;

    }


    function gerarUltimos12Meses() {

        const meses = [];
        const agora = new Date();

        for (let i = 12; i >= 0; i--) {
            const d = new Date(agora.getFullYear(), agora.getMonth() - i, 1);
            const ano = d.getFullYear();
            const mes = String(d.getMonth() + 1).padStart(2, "0");
            meses.push(`${ano}-${mes}`);
        }

        return meses;
    }


    function gerarDiasDoMes(ano, mes) {

        //mês no JS é 0-indexado (0 = Janeiro), mas aqui vamos passar 1-indexado (1 = Janeiro)
        const dias = [];
        const ultimoDia = new Date(ano, mes, 0).getDate(); // último dia do mês

        for (let i = 1; i <= ultimoDia; i++) {
            const diaStr = String(i).padStart(2, "0");
            const mesStr = String(mes).padStart(2, "0");
            dias.push(`${ano}-${mesStr}-${diaStr}`);
        }

        return dias;
    }


    useEffect(() => {

        if (!selectedMonth || !dash1?.resumo) return;

        const [ano, mes] = selectedMonth.split("-");
        const diasDoMes = gerarDiasDoMes(Number(ano), Number(mes));

        const chartDataDiario = diasDoMes.map((key) => {
            const valores = dash1.resumo.por_dia?.[key] || { total: 0, resolvidos: 0, nao_resolvidos: 0 };
            return {dia: key.split("-")[2], concluido: valores.resolvidos, nconcluido: valores.nao_resolvidos,};
        });

        setDash1((prev) => ({ ...prev, chartDiario: chartDataDiario }));

    }, [selectedMonth]);


    function getMesAtual() {

        const hoje = new Date();
        const ano = hoje.getFullYear();
        const mes = String(hoje.getMonth() + 1).padStart(2, "0");
        return `${ano}-${mes}`;

    }



    return(
        <div className="context">
        
            <Header access={1}></Header>

            <div className="content">

                <div className="ft_topico">Performance do agente</div>
                <div className="ft_descricao">Veja o desempenho do seu agente, compare períodos e métricas e obtenha mais informações sobre seu público e sua rotina.</div>
                <div className="space"></div>

                <div className="performance_resume">
                    <div className="performance_resume_1a">
                        <div className="peformance_resume_box">
                            { !loaded1 ? (<><span className="performance_load">carregando ...</span></>) : (
                            <>
                            <span className="peformance_resume_title">Atendimentos</span>
                            <span className="peformance_resume_number" style={{color: "green"}}>{dash1.resumo?.total_atendimentos ?? 0}</span>
                            </>
                            )}
                        </div>
                    </div>
                    <div className="performance_resume_1b">
                        <span className="performance_resume_signal">=</span>
                    </div>
                    <div className="performance_resume_1a">
                        <div className="peformance_resume_box">
                            { !loaded1 ? (<><span className="performance_load">carregando ...</span></>) : (
                            <>
                            <span className="peformance_resume_title">Resolvidos</span>
                            <span className="peformance_resume_number" style={{color: "blue"}}>{dash1.resumo?.resolvidos ?? 0}</span>
                            </>
                            )}
                        </div>
                    </div>
                    <div className="performance_resume_1b">
                        <span className="performance_resume_signal">+</span>
                    </div>
                    <div className="performance_resume_1a">
                        <div className="peformance_resume_box">
                            { !loaded1 ? (<><span className="performance_load">carregando ...</span></>) : (
                            <>
                            <span className="peformance_resume_title">Não resolvidos</span>
                            <span className="peformance_resume_number" style={{color: "red"}}>{dash1.resumo?.nao_resolvidos ?? 0}</span>
                            </>
                            )}
                        </div>
                    </div>
                    <div className="performance_resume_1b"></div>
                    <div className="performance_resume_1b"></div>
                    <div className="performance_resume_1b"></div>
                    <div className="performance_resume_1c">
                        <div className="peformance_resume_box">
                            { !loaded1 ? (<><span className="performance_load">carregando ...</span></>) : (
                            <>
                            <span className="peformance_resume_title">Tempo médio de atendimento</span>
                            <span className="peformance_resume_number" style={{color: "green"}}>{dash1.resumo?.media_tempo_resolucao_formatado?.replace('min', ' minutos') ?? 0}</span>
                            </>
                            )}
                        </div>
                    </div>
                </div>
                <div className="space"></div>
            
                <div className="peformance_box">
                    <span className="peformance_box_space"></span>
                    <span className="title_form">Número de atendimentos consolidados por mês</span>
                    <span className="peformance_box_space"></span>
                    <div className="performance_box_graphic">
                        { !loaded1 ? (<><span className="performance_load">carregando ...</span></>) : (
                        <>
                        <ResponsiveContainer>
                            <BarChart margin={{ top: 20 }} data={dash1?.chart || []} onClick={(data) => {
                                if (data && data.activeLabel) {
                                    //Exemplo: "Out/25" → precisamos converter para "2025-10"
                                    const label = data.activeLabel;
                                    const partes = label.split("/");
                                    const mes = partes[0];
                                    const ano = "20" + partes[1];
      
                                    //Mapeia abreviação → número do mês
                                    const mapa = {
                                        Jan: "01", Fev: "02", Mar: "03", Abr: "04",
                                        Mai: "05", Jun: "06", Jul: "07", Ago: "08",
                                        Set: "09", Out: "10", Nov: "11", Dez: "12"
                                    };
                                    const mesNum = mapa[mes] || "01";

                                    setSelectedMonth(`${ano}-${mesNum}`);}
                                }}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="mes" tick={{ fontSize: 10 }} />
                            <YAxis hide={true} />
                            
{/* Tooltip com o cursor cinza padrão */}
    <Tooltip cursor={{ fill: "rgba(200, 200, 200, 0.2)" }} />

    {/* 🔶 Destaque fixo no mês selecionado */}
    {selectedMonth && (
      <ReferenceArea
        x1={dash1?.chart?.find((item) => item.mes === formatarMes(selectedMonth))?.mes}
        x2={dash1?.chart?.find((item) => item.mes === formatarMes(selectedMonth))?.mes}
        ifOverflow="extendDomain"
        fill="rgba(255, 215, 0, 0.8)" // amarelo translúcido
      />
    )}

                            <Legend wrapperStyle={{ fontSize: 11 }} formatter={(value, entry) => {if (value === 'concluido') return 'Resolvido'; if (value === 'nconcluido') return 'Não Resolvido'; return value;}} />
                            <Bar dataKey="concluido" stackId="a" fill="blue" shape={(props) => (<rect {...props} tabIndex={-1} style={{ cursor: "pointer" }} />)} />
                            <Bar dataKey="nconcluido" stackId="a" fill="red" shape={(props) => (<rect {...props} tabIndex={-1} style={{ cursor: "pointer" }} />)} >
                            <LabelList
                                dataKey="nconcluido"
                                position="top"
                                content={(props) => {
                                    const { x, y, width, index } = props;
                                    const total = (dash1?.chart?.[index]?.concluido || 0) + (dash1?.chart?.[index]?.nconcluido || 0);
                                    return (<text x={x + width / 2} y={y - 5} textAnchor="middle" fill="black" fontSize={12}>{total}</text>);
                                }} />
                            </Bar>
                            </BarChart>
                        </ResponsiveContainer>
                        </>
                        )}
                    </div>
                    <span className="peformance_box_space"></span>
                </div>
                <div className="space"></div>

                <div className="peformance_box">
                    <span className="peformance_box_space"></span>
                    <span className="title_form">Número de atendimentos consolidados por dia {"(Período: " + formatarMes(selectedMonth) + ")"}</span>
                    <span className="peformance_box_space"></span>
                    <div className="performance_box_graphic">
                        { !loaded1 ? (<><span className="performance_load">carregando ...</span></>) : (
                        <>
                        <ResponsiveContainer>
                            <BarChart margin={{ top: 20 }} data={dash1?.chartDiario || []}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="dia" tick={{ fontSize: 10 }} />
                            <YAxis hide={true} />
                            <Tooltip />
                            <Legend wrapperStyle={{ fontSize: 11 }} formatter={(value, entry) => {if (value === 'concluido') return 'Resolvido'; if (value === 'nconcluido') return 'Não Resolvido'; return value;}} />
                            <Bar dataKey="concluido" stackId="a" fill="blue" />
                            <Bar dataKey="nconcluido" stackId="a" fill="red">
                            <LabelList
                                dataKey="nconcluido"
                                position="top"
                                content={(props) => {
                                    const { x, y, width, index } = props;
                                    const total = (dash1?.chartDiario?.[index]?.concluido || 0) + (dash1?.chartDiario?.[index]?.nconcluido || 0);
                                    return (<text x={x + width / 2} y={y - 5} textAnchor="middle" fill="black" fontSize={12}>{total}</text>);
                                }} />
                            </Bar>
                            </BarChart>
                        </ResponsiveContainer>
                        </>
                        )}
                    </div>
                    <span className="peformance_box_space"></span>
                </div>


                <div className="space"></div>
                <div className="space"></div>
                <div className="space"></div>
                    
            </div>
                    
        <Footer access={1}></Footer>
                    
        </div>
    )
}